export const CHANGE_CURRENT_PAGE = 'productColors/CHANGE_CURRENT_PAGE'
export const CHANGE_PAGE_SIZE = 'productColors/CHANGE_PAGE_SIZE'
export const CREATE_PRODUCT_COLOR = 'productColors/CREATE_PRODUCT_COLOR'
export const FETCH_PRODUCT_COLOR = 'productColors/FETCH_PRODUCT_COLOR'
export const FETCH_PRODUCT_COLORS_LIST = 'productColors/FETCH_PRODUCT_COLORS_LIST'
export const REMOVE_PRODUCT_COLOR = 'productColors/REMOVE_PRODUCT_COLOR'
export const UPDATE_PRODUCT_COLOR = 'productColor/UPDATE_PRODUCT_COLOR'
export const FETCH_PRODUCT_COLORS_FOR_OPTIONS = 'productColor/FETCH_PRODUCT_COLORS_FOR_OPTIONS'
